import ProductCategoriesNavbar from './ProductCategoriesNavbar'

export default ProductCategoriesNavbar
